import { getEncryptedTextV2 } from "./common";
import environment from "../constants/environments";
import { DIET_PLAN_TITLE } from "../constants/common";

export type BulkUploadPatientRecordsPayload = {
  patient_id: string;
  records: Array<{
    title: string;
    test_name: string;
    extension_type: string;
    document_data: string[];
    container_account: string;
    container_name: string;
    meta_data?: Record<string, unknown>;
  }>;
};

export type DietPlanRecordMetaData = {
  dietPlanId?: string;
  planName?: string;
  planStatus?: string;
  planStartDate?: string;
  planEndDate?: string;
  assignedBy?: string;
  assignedByName?: string;
};

export type DietPlanRecordPayloadInput = {
  patientId: string;
  fileName: string;
  metaData?: DietPlanRecordMetaData;
};

export const buildBulkUploadFormData = (
  recordsPayload: BulkUploadPatientRecordsPayload,
  files: File[],
) => {
  const formData = new FormData();
  files.forEach((file) => formData.append("file", file));
  formData.append("payload", getEncryptedTextV2(recordsPayload));
  return formData;
};

export const buildDietPlanRecordPayload = ({
  patientId,
  fileName,
  metaData = {},
}: DietPlanRecordPayloadInput): BulkUploadPatientRecordsPayload => {
  const {
    dietPlanId,
    planName,
    planStatus,
    planStartDate,
    planEndDate,
    assignedBy,
    assignedByName,
  } = metaData;

  return {
    patient_id: patientId,
    records: [
      {
        title: DIET_PLAN_TITLE,
        test_name: DIET_PLAN_TITLE,
        extension_type: "pdf",
        document_data: [fileName],
        container_account:
          environment.AZURE_STORAGE_ACCOUNT || "aztatvaprodstorage",
        container_name: "patient-reports",
        meta_data: {
          ...(dietPlanId ? { diet_plans_id: dietPlanId } : {}),
          ...(planName ? { plan_name: planName } : {}),
          ...(planStatus ? { plan_status: planStatus } : {}),
          ...(planStartDate ? { start_date: planStartDate } : {}),
          ...(planEndDate ? { end_date: planEndDate } : {}),
          ...(assignedBy ? { assigned_by: assignedBy } : {}),
          ...(assignedByName ? { assigned_by_name: assignedByName } : {}),
        },
      },
    ],
  };
};
